import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc0130b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-2" }, "Még nincs szálláskérése.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body-2 text-medium-emphasis mb-4" }, "Indítson egy új kérést az ajánlatokért!", -1))
const _hoisted_4 = { class: "text-h6" }
const _hoisted_5 = { class: "text-h3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Aktív foglalások", -1))
const _hoisted_7 = { class: "text-h3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Várakozó ajánlatok", -1))
const _hoisted_9 = { class: "text-h3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Közelgő szállások", -1))
const _hoisted_11 = { class: "d-flex align-center justify-space-between mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Aktív kérések", -1))
const _hoisted_13 = { class: "d-flex align-center justify-space-between mb-3" }
const _hoisted_14 = {
  class: "font-weight-bold",
  style: {"font-family":"monospace"}
}
const _hoisted_15 = { class: "text-body-2 text-medium-emphasis ml-3" }
const _hoisted_16 = { class: "text-body-2 text-medium-emphasis ml-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, null, -1))
const _hoisted_18 = { class: "d-flex align-center justify-space-between mb-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Közelgő szállások", -1))
const _hoisted_20 = { class: "text-body-1" }
const _hoisted_21 = { class: "text-body-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_skeleton_loader, {
              class: "mb-4",
              type: "card",
              height: "64"
            }),
            _createVNode(_component_v_row, { class: "mb-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, {
                      type: "card",
                      height: "120"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, {
                      type: "card",
                      height: "120"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, {
                      type: "card",
                      height: "120"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_skeleton_loader, {
              class: "mb-4",
              type: "card",
              height: "160"
            }),
            _createVNode(_component_v_skeleton_loader, {
              class: "mb-4",
              type: "card",
              height: "160"
            })
          ], 64))
        : ($setup.error)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 1,
              class: "mb-4",
              type: "error",
              variant: "tonal"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  color: "error",
                  onClick: $setup.fetchDashboardData
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Újrapróbálás")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode("Nem sikerült betölteni az adatokat.")
              ]),
              _: 1
            }))
          : ($setup.isNewUser)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_v_card, {
                  class: "mb-6",
                  variant: "tonal",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "d-flex align-center justify-space-between" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, "Üdvözöljük, " + _toDisplayString($setup.greeting) + "!", 1),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          "prepend-icon": "mdi-plus",
                          onClick: $setup.openCreateDialog
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Új szálláskérés")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  class: "mx-auto text-center pa-8",
                  "max-width": "500",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      class: "mb-4",
                      size: "64",
                      color: "grey"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-bed-outline")
                      ]),
                      _: 1
                    }),
                    _hoisted_2,
                    _hoisted_3,
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      "prepend-icon": "mdi-plus",
                      onClick: $setup.openCreateDialog
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Első szálláskérés indítása")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_v_card, {
                  class: "mb-4",
                  variant: "tonal",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "d-flex align-center justify-space-between" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, "Üdvözöljük, " + _toDisplayString($setup.greeting) + "!", 1),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          "prepend-icon": "mdi-plus",
                          onClick: $setup.openCreateDialog
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Új szálláskérés")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "mb-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "stat-card",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.navigateToBookings('BOOKED'))),
                          style: {"border-left":"4px solid rgb(var(--v-theme-success))","cursor":"pointer"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, _toDisplayString($setup.activeBookingsCount), 1),
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "stat-card",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.navigateToInquiries('OFFER SENT'))),
                          style: {"border-left":"4px solid rgb(var(--v-theme-warning))","cursor":"pointer"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.pendingOffersCount), 1),
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "stat-card",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.navigateToBookings('BOOKED'))),
                          style: {"border-left":"4px solid rgb(var(--v-theme-info))","cursor":"pointer"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, _toDisplayString($setup.upcomingStaysCount), 1),
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                ($setup.activeInquiries.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        ($setup.allActiveInquiriesCount > 3)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              variant: "text",
                              color: "primary",
                              size: "small",
                              onClick: $setup.navigateToInquiries
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mind megtekintése →")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeInquiries, (inquiry) => {
                        return (_openBlock(), _createBlock(_component_v_card, {
                          class: "mb-3",
                          key: inquiry.id,
                          onClick: ($event: any) => ($setup.navigateToInquiryDetails(inquiry.id)),
                          style: {"cursor":"pointer"},
                          hover: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_14, _toDisplayString($setup.formatPublicReference(inquiry.publicReference)), 1),
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(inquiry.area), 1),
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(inquiry.from) + " – " + _toDisplayString(inquiry.to), 1)
                                  ]),
                                  (inquiry.status === 'OFFER SENT')
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        variant: "tonal",
                                        color: "warning",
                                        size: "small",
                                        onClick: _withModifiers(($event: any) => ($setup.navigateToInquiryDetails(inquiry.id)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Ajánlatok megtekintése")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode($setup["InquiryProgressIndicator"], {
                                  status: inquiry.status
                                }, null, 8, ["status"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      _hoisted_17
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  ($setup.upcomingStays.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "text",
                        color: "primary",
                        size: "small",
                        onClick: $setup.navigateToBookings
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Mind megtekintése →")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                ($setup.upcomingStays.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.upcomingStays, (stay) => {
                      return (_openBlock(), _createBlock(_component_v_card, {
                        class: "mb-3",
                        key: stay.publicReference,
                        onClick: ($event: any) => ($setup.navigateToBookingDetails(stay.publicReference)),
                        style: {"cursor":"pointer"},
                        hover: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-domain",
                            title: stay.accommodation,
                            subtitle: `${stay.startDate} – ${stay.endDate}  ·  ${stay.numberOfPeople} fő  ·  Költséghely: ${stay.costCenterName}`
                          }, null, 8, ["title", "subtitle"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  : (_openBlock(), _createBlock(_component_v_alert, {
                      key: 2,
                      class: "mb-4",
                      type: "info",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Nincs közelgő szállás.")
                      ]),
                      _: 1
                    })),
                ($setup.authStore.isCompanyAdmin)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 3,
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, { variant: "outlined" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, { class: "d-flex align-center justify-space-between" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_v_icon, {
                                        class: "mr-2",
                                        color: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-account-group")
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", _hoisted_20, _toDisplayString($setup.companyUsersCount) + " felhasználó", 1)
                                    ]),
                                    _createVNode(_component_v_btn, {
                                      variant: "text",
                                      color: "primary",
                                      size: "small",
                                      onClick: $setup.navigateToUsers
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Meghívás")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, { variant: "outlined" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, { class: "d-flex align-center justify-space-between" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_v_icon, {
                                        class: "mr-2",
                                        color: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-folder-outline")
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", _hoisted_21, _toDisplayString($setup.companyCostCentersCount) + " költséghely", 1)
                                    ]),
                                    _createVNode(_component_v_btn, {
                                      variant: "text",
                                      color: "primary",
                                      size: "small",
                                      onClick: $setup.navigateToCostCenters
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Kezelés")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64)),
      _createVNode($setup["CustomerAccommodationInquiryFormDialog"], {
        show: $setup.showCreateDialog,
        onInquiryCreated: $setup.onInquiryCreated,
        onCloseCreateInquiry: $setup.closeCreateDialog
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}